module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.912ec66.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg
// module id = 795
// module chunks = 2